import ServiceError from '../../core/errors/ServiceError';

export const validServices = {
  video: 'video',
  videoTag: 'videoTag',
  directYoutube: 'directYoutube',
  directVimeo: 'directVimeo',
};

function validateServiceName(configPOC) {
  switch (configPOC.service) {
    case validServices.video:
    case validServices.directVimeo:
    case validServices.directYoutube:
      if (!configPOC.idVideo) {
        throw new ServiceError('idVideo is required', '00014');
      }
      break;

    case validServices.videoTag:
      if (!configPOC.idTag) {
        throw new ServiceError('idTag is required', '00014');
      }
      // eslint-disable-next-line no-param-reassign
      if (!configPOC.numVideos) configPOC.numVideos = 5;
      break;

    default:
      throw new ServiceError('Invalid service value', '00017');
  }
}

export default function validateParamsPOC(configPOC) {
  if (!configPOC) {
    throw new ServiceError('No hay url para servicio de POC', '00013');
  }
  // Check if the object is empty
  if (Object.keys(configPOC).length === 0) {
    throw new ServiceError('Object must have one or more attributes', '00013');
  }

  if (!configPOC.idPub) {
    throw new ServiceError('idPub is required', '00015');
  }

  if (!configPOC.service) {
    // eslint-disable-next-line no-param-reassign
    configPOC.service = 'video';
  }

  validateServiceName(configPOC);
}
